var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 31.5H11.2C7.24931 31.5 4.61391 30.7068 2.95355 29.0464C1.2932 27.3861 0.5 24.7507 0.5 20.8V11.2C0.5 7.24931 1.2932 4.61391 2.95355 2.95355C4.61391 1.2932 7.24931 0.5 11.2 0.5H20.8C24.7507 0.5 27.3861 1.2932 29.0464 2.95355C30.7068 4.61391 31.5 7.24931 31.5 11.2V20.8C31.5 24.7507 30.7068 27.3861 29.0464 29.0464C27.3861 30.7068 24.7507 31.5 20.8 31.5Z",
    stroke: "#0099FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3467L16 19.3467L20 15.3467",
    stroke: "#0099FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3467V8.67999",
    stroke: "#0099FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.0133C13.1867 23.7467 18.8133 23.7467 24 22.0133",
    stroke: "#0099FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0f0eef5db77285d03d01b0de6386c644.svg";
export { ForwardRef as ReactComponent };